import mapFunction from './mapResources';

export default mapFunction('tools', {
    isFetching: false,
    items: [] 
});